import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";

const RejectedRegistrations = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onValue(ref(db, "rejectedRegistrations"), (snapshot) => {
      if (snapshot.exists()) {
        const data = Object.entries(snapshot.val())
          .map(([id, v]) => ({ id, ...v }))
          .sort((a, b) => (b.rejectedAt || 0) - (a.rejectedAt || 0));
        setRegistrations(data);
      } else {
        setRegistrations([]);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="container my-5 text-center">
        <div className="spinner-border text-danger" role="status" />
        <p className="mt-3">Loading...</p>
      </div>
    );
  }

  return (
    <div className="container my-4">
      <div className="card shadow">
        <div className="card-header bg-danger text-white">
          <h5 className="mb-0">❌ Rejected Registrations ({registrations.length})</h5>
        </div>
        <div className="card-body p-0">
          {registrations.length === 0 ? (
            <div className="text-center py-5">
              <h6 className="text-muted">No rejected registrations found</h6>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>नाम</th>
                    <th>मोबाइल</th>
                    <th>कारण</th>
                    <th>तारीख</th>
                  </tr>
                </thead>
                <tbody>
                  {registrations.map((reg, index) => (
                    <tr key={reg.id}>
                      <td>{index + 1}</td>
                      <td>{reg.headName || '-'}</td>
                      <td>{reg.mobile || '-'}</td>
                      <td><small className="text-muted">{reg.reason || '-'}</small></td>
                      <td>{reg.rejectedAt ? new Date(reg.rejectedAt).toLocaleDateString() : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RejectedRegistrations;